<template>
  <div class="common-audio-switch"></div>
</template>

<script>
export default {
  name: "AudioSwitch",
  methods: {
    onClick(bool) {
      this.$store.commit("setAudioSwitch", bool);
    }
  }
};
</script>

<style lang="scss" scoped>
.common-audio-switch {
  img {
    width: 28px;
    height: 28px;
  }
}
</style>